import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import Peer from "peerjs";
import { auth } from "../firebase";

export default function VideoCallPage() {
  const { roomCode } = useParams();
  const localVideoRef = useRef(null);
  const remoteVideoRef = useRef(null);
  const peerInstance = useRef(null);
  const currentCall = useRef(null);
  const [localStream, setLocalStream] = useState(null);
  const [remoteStream, setRemoteStream] = useState(null);
  const userId = auth.currentUser?.uid;

  useEffect(() => {
    const setupPeer = async () => {
      if (!userId) return;
      const peer = new Peer(userId);
      peerInstance.current = peer;

      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });
      localVideoRef.current.srcObject = stream;
      setLocalStream(stream);

      peer.on("call", (call) => {
        call.answer(stream);
        call.on("stream", (remoteStream) => {
          remoteVideoRef.current.srcObject = remoteStream;
          setRemoteStream(remoteStream);
        });
        currentCall.current = call;
      });

      peer.on("open", (id) => {
        console.log("PeerJS ready with ID:", id);
      });
    };

    setupPeer();

    return () => {
      // Clean up on unmount
      if (currentCall.current) currentCall.current.close();
      if (localStream) localStream.getTracks().forEach(track => track.stop());
      if (peerInstance.current) peerInstance.current.destroy();
    };
  }, [userId]);

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh", padding: 20 }}>
      <h2>تماس تصویری - اتاق {roomCode}</h2>

      <div style={{ display: "flex", gap: 20 }}>
        <div>
          <h4>ویدیوی من</h4>
          <video ref={localVideoRef} autoPlay playsInline muted style={{ width: 320, height: 240, borderRadius: 8 }} />
        </div>

        <div>
          <h4>ویدیوی طرف مقابل</h4>
          <video ref={remoteVideoRef} autoPlay playsInline style={{ width: 320, height: 240, borderRadius: 8 }} />
        </div>
      </div>
    </div>
  );
}
